import { useContext } from 'react';

import ToastContext from '../context/ToastProvider';

export default function useToast() {
  return useContext(ToastContext);
}
